import { createSlice } from '@reduxjs/toolkit';
import { getHospitalReportsList } from '../../../rtk-apis/reports/getHopsitalReportsList';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const getHospitalReportsListSlice = createSlice({
  name: 'getHospitalReportsListSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getHospitalReportsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getHospitalReportsList.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(getHospitalReportsList.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = getHospitalReportsListSlice.actions;
export default getHospitalReportsListSlice.reducer;
